<div
  class="ui vertical basic segment"
  [ngClass]="{ loading: pending }"
  appMargin="0"
  appPadding="0"
>
  <div class="wrapper" *ngIf="pendingArray && pendingArray.length > 0">
    <div class="pills">
      <esl-pills
        color="#FFAC33"
        textColor="#FFFFFF"
        label="PENDING VERIFICATION"
      ></esl-pills>
      <img
        src="assets/icons/trash.svg"
        suiPopup
        [popupInverted]="true"
        popupPlacement="bottom"
        popupText="Delete Request"
        (click)="deleteRequest.emit(pendingHistory.changeRequestId)"
        style="cursor: pointer"
        alt=""
      />
    </div>
    <div demo class="ui info message">
      <div class="content">
        <img src="assets/icons/yellow-icon.svg" alt="" />
        <p>
          Your pending changes will be reviewed shortly. If you attempt to make
          additional changes before these are processed, the pending update will
          be discarded in favor of the new one. However, you can send us a chat
          message <a href="/contractor/chat-window/conversation-screen/empty"
            >here</a
          >
          if you have any question or feedback.
        </p>
      </div>
    </div>

    <div
      class="containerNew"
      *ngFor="let director of pendingStrcuture; let i = index"
    >
      <div class="contents">
        <div class="image">
          <img
            *ngIf="director.photographDocumentPath"
            src="{{ baseUrl }}/public/image/?media={{
              director?.photographDocumentPath
            }}"
          />
          <img
            *ngIf="!director.photographDocumentPath"
            src="assets/avatar/1.jpg"
          />
        </div>
        <div class="content_name">
          <div class="tag" *ngIf="affiliateTypeId === 'shareholder_type'">
            {{
              director?.companyName && director?.companyRegNumber
                ? "Company"
                : "Individual"
            }}
          </div>
          <div class="name">
            <h2>{{ director?.firstName }} {{ director?.lastName }}</h2>
          </div>
          <div class="information">
            <div class="info" style="width: 145px">
              <p>Date Added</p>
              <h4>{{ director?.dateCreated | date: "d MMM, y h:mm a" }}</h4>
            </div>
            <div class="info" style="width: fit-content">
              <p>Added By</p>
              <h4>{{ director?.createdBy | createdBy }}</h4>
            </div>
            <div class="info" style="width: 145px">
              <p>Action Type</p>
              <div class="pills">
                <esl-pills
                  [color]="getColorForLabel(director?.actionType)"
                  [textColor]="getColorTextForLabel(director?.actionType)"
                  label="{{
                    director?.actionType === 'NONE'
                      ? 'NOT CHANGED'
                      : director?.actionType
                  }}"
                ></esl-pills>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="action_button">
        <img
          src="assets/icons/View.svg"
          suiPopup
          [popupInverted]="true"
          popupPlacement="bottom"
          popupText="View"
          (click)="directorRecord(director)"
          alt=""
        />
      </div>
    </div>
    <div
      *ngIf="pendingStrcuture && pendingStrcuture.length < 1"
      style="width: 100%; margin: 0 auto"
      class="no-record"
    >
      <h3
        style="
          font-size: 16px;
          font-weight: 700;
          margin-top: 2.5rem;
          text-align: center;
        "
      >
        This Section has no pending Record
      </h3>
      <p
        style="
          font-size: 12px;
          font-weight: 400;
          margin-top: 16px;
          text-align: center;
        "
      >
        Click on the Update Button to make Updates
      </p>
    </div>

    <div class="supporting_document">
      <h2>Uploaded Supporting Documents</h2>
      <div
        class="document_name"
        *ngFor="let document of pendingDocuments?.documents; let i = index"
      >
        <h3>
          {{
            document?.documentTypeId.documentTypeName
              ? document?.documentTypeId.documentTypeName
              : document?.documentName
          }}
        </h3>
        <div class="linked_document_container">
          <div class="more_information">
            <h4 class="class">
              {{
                document?.documentTypeId.documentTypeName
                  ? document?.documentTypeId.documentTypeName
                  : document?.documentName
              }}
            </h4>
            <div class="linked_not">
              {{ document?.checkbox ? "LINKED" : "UPLOADED" }}
            </div>
          </div>
          <div class="linked_document" *ngIf="document?.checkbox">
            <div class="contents">
              <div class="content_name">
                <div class="name">
                  <img src="assets/icons/document-text.svg" alt="" />
                  <h5>
                    {{ document?.documentName }}
                  </h5>
                </div>
                <div class="information">
                  <div class="info">
                    <p>ADDED BY</p>
                    <div class="flex">
                      <h4>
                        <img src="assets/icons/User.svg" alt="" />{{
                          document?.createdBy | createdBy
                        }}
                      </h4>
                      <h4>
                        <img src="assets/icons/Clock 2.svg" alt="" />{{
                          document?.dateCreated | date: "d MMM, y h:mm a"
                        }}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="action_button">
              <img
                src="assets/icons/Frame 5492.svg"
                suiPopup
                [popupInverted]="true"
                popupPlacement="bottom"
                popupText="View"
                (click)="viewDocument(document)"
                alt=""
              />
            </div>
          </div>
          <div class="added_document" *ngIf="!document?.checkbox">
            <div class="contents">
              <div class="image">
                <img src="assets/icons/Frame.svg" alt="" />
              </div>
              <div class="content_name">
                <h5>
                  {{ document?.documentName }}
                </h5>
              </div>
            </div>
            <div class="action_button">
              <img
                src="assets/icons/Frame 5492.svg"
                suiPopup
                [popupInverted]="true"
                popupPlacement="bottom"
                popupText="View"
                (click)="viewDocument(document)"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="pendingArray && pendingArray.length < 1"
    style="width: 100%; margin: 0 auto"
    class="no-record"
  >
    <h3
      style="
        font-size: 16px;
        font-weight: 700;
        margin-top: 2.5rem;
        text-align: center;
      "
    >
      There is no pending verification request
    </h3>
  </div>
  <div
    *ngIf="
      pendingDocuments?.documents && pendingDocuments?.documents.length < 1
    "
    style="width: 100%; margin: 0 auto"
    class="no-record"
  >
    <h3
      style="
        font-size: 16px;
        font-weight: 700;
        margin-top: 2.5rem;
        text-align: center;
      "
    >
      This Record has no uploaded supporting document
    </h3>
    <p
      style="
        font-size: 12px;
        font-weight: 400;
        margin-top: 16px;
        text-align: center;
      "
    >
      Go to the Supporting Document Section and upload needed Document
    </p>
  </div>
</div>
